module.exports = __webpack_public_path__ + "img/about.31e9bc63.png";